"use strict";

const Filters = () => {
    const init = () => {
        $(function() {
            var $forms = $('.js-filters-form');
            if ($forms.length > 0) {
                $forms.each(function(){
                    var $form = $(this);
                    var $radios = $form.find('.js-radio');
                    var $checkboxes = $form.find('.js-checkbox');
                    var $textSelect = $form.find('.js-text-select');
                    var $postcode = $form.find('.js-postcode-input');
                    var $multiSelect = $form.find('.js-multi-select');
                    var $currentPage = $form.find('.current-page');
                    var $modeToggle = $('.js-mode-toggle');
                    
                    $radios.on('click', function(e){
                        e.preventDefault();
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $radios.filter('[data-name="'+$input.attr('name')+'"]').find('input').prop('checked', false);
                            $input.prop('checked', true);
                        }
                        $currentPage.val(1)
                        $form.find('.ajax-submit').trigger('click');
                        if($(this).data('slug') !== undefined) {
                            window.history.pushState({}, "", window.location.protocol + '//' + window.location.host + '/' + $(this).data('slug'));
                        }
                        checkConflicts();
                    });
                    
                    $checkboxes.on('click', function(){
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $input.prop('checked', true);
                        }
                        $form.find('.ajax-submit').trigger('click');
                        checkConflicts();
                    });

                    $form.find('input[type="text"]').on('change', function(){
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $form.find('.checkbox input').on('change', function(){
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $form.find('[data-conflicts-select]').on('change', function(){
                        checkConflicts();
                    });

                    $('.js-filters-reset').on('click', function(){
                        $form.find('input').prop('checked', false);
                        $form.find('.nice-select').val('');
                        $form.find('.nice-select').niceSelect('update');
                        $form.find('input[type="text"]').val('');
                        $form.find('.filled, .focused').removeClass('filled focused');
                        $form.find('.js-multi-select-selected').text($form.find('.js-multi-select-selected').data('default'));
                        $form.find('.js-multi-select input').val('');
                        $form.find('.js-multi-select-option').removeClass('active')
                        history.pushState({}, null, window.location.pathname);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $textSelect.find('.js-text-select-input').on('keyup', function(){
                        var $this = $(this)
                        var $parent = $this.parents('.js-text-select')
                        if($this.val() !== '') {
                            $this.siblings('.js-text-select-options').addClass('open');
                            var foundOne = false;
                            $parent.find('.js-text-select-option').each(function(){
                                if($(this).data('value').toLowerCase().indexOf($this.val().toLowerCase()) >= 0){
                                    $(this).show();
                                    foundOne = true;
                                }else{
                                    $(this).hide();
                                }
                            });
                            if(!foundOne){
                                $this.siblings('.js-text-select-options').removeClass('open');
                            }
                        }else{
                            $this.siblings('.js-text-select-options').removeClass('open');
                            $parent.find('.js-text-select-option').show();
                        }
                    });

                    $textSelect.find('.js-text-select-input').on('focus', function(){
                        var $this = $(this);
                        $this.siblings('.js-text-select-options').addClass('open');
                    });
                    
                    $textSelect.find('.js-text-select-option').on('click', function(){
                        var $this = $(this);
                        $this.parents('.js-text-select').find('.js-text-select-input').val($this.data('value'));
                        $this.parents('.js-text-select').addClass('filled');
                        $this.parents('.js-text-select-options').removeClass('open');
                        $form.find('.ajax-submit').trigger('click');
                    });
                    
                    $form.find('.js-filters-extra-toggle').on('click', function(){
                        $(this).toggleClass('open');
                        $form.find('.js-filters-extra').slideToggle();
                        $form.find('.js-filters-spacer').slideToggle();
                    });

                    $multiSelect.find('.js-multi-select-selected').on('click', function(){
                        var $this = $(this);
                        $this.siblings('.js-multi-select-options').toggleClass('open');
                    });
                    
                    $(window).click(function(e) {
                        if(!$(e.target).hasClass('js-multi-select') && !$(e.target).parents('.js-multi-select').length && !$(e.target).hasClass('ajax-submit')){
                            $multiSelect.find('.js-multi-select-options').removeClass('open');
                        }
                        if(!$(e.target).hasClass('js-text-select') && !$(e.target).parents('.js-text-select').length && !$(e.target).hasClass('ajax-submit')){
                            $textSelect.find('.js-text-select-options').removeClass('open');
                        }
                    });
                    
                    $multiSelect.find('.js-multi-select-option').on('click', function(){
                        var $this = $(this);
                        var $parent = $this.parents('.js-multi-select');
                        if($this.hasClass('active')){
                            $this.removeClass('active');
                            var $selected = $this.parents('.js-multi-select').find('.js-multi-select-selected');
                            if($this.siblings('.js-multi-select-option.active').length){
                                var prevAll = $this.prevAll('.js-multi-select-option.active').length;
                                var nextAll = $this.nextAll('.js-multi-select-option.active').length;
                                if(prevAll && nextAll){
                                    if(prevAll > nextAll){
                                        $this.nextAll('.js-multi-select-option').removeClass('active');
                                    }else{
                                        $this.prevAll('.js-multi-select-option').removeClass('active');
                                    }
                                }
                                var result = buildMultiSelectString($selected, $this.parents('.js-multi-select').find('.js-multi-select-option.active'));
                                $parent.find('input[name$="min"]').val(result.min);
                                $parent.find('input[name$="max"]').val(result.max);
                            }else{
                                $selected.text($selected.data('default'));
                                $parent.find('input').val('');
                            }
                        }else{
                            $this.addClass('active');
                            var $selected = $this.parents('.js-multi-select').find('.js-multi-select-selected');
                            if($this.prevAll('.js-multi-select-option.active').length){
                                $this.prevUntil('.active').addClass('active');
                            }
                            if($this.nextAll('.js-multi-select-option.active').length){
                                $this.nextUntil('.active').addClass('active');
                            }
                            var result = buildMultiSelectString($selected, $this.parents('.js-multi-select').find('.js-multi-select-option.active'));
                            $parent.find('input[name$="min"]').val(result.min);
                            $parent.find('input[name$="max"]').val(result.max);
                        }
                        $form.find('.ajax-submit').trigger('click');
                    });


                    function buildMultiSelectString($selected, $options){
                        var min = -1;
                        var max = 0;
                        $options.each(function(){
                            if($(this).data('min') < min || min < 0){
                                min = $(this).data('min')
                            }
                            if($(this).data('max') > max || $(this).data('max') == 0){
                                max = $(this).data('max')
                            }
                        });
                        if(max > 0){
                            if(min > 0){
                                $selected.text('$' + min.toLocaleString() + ' - $' + max.toLocaleString());
                            }else{
                                $selected.text('< $' + max.toLocaleString());
                            }
                        }else{
                            $selected.text('$' + min.toLocaleString() + '+');
                        }
                        return {
                            'min': min,
                            'max': max
                        };
                    }

                    $modeToggle.on('click', function(){
                        $modeToggle.removeClass('active');
                        $(this).addClass('active');
                        $(this).parents('.js-map-holder').removeClass('list-view map-view');
                        $(this).parents('.js-map-holder').addClass($(this).data('id')+'-view');
                        $form.find('[name="mode"]').val($(this).data('id'));
                        $form.find('.ajax-submit').trigger('click');
                    });

                    if($postcode.length){
                        if (navigator.geolocation) {
                            function success(position){
                                $.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+position.coords.latitude+','+position.coords.longitude+'&key='+$postcode.data('key'), function(data){
                                    if(data.results.length){
                                        var postcode = data.results[0].address_components.pop()
                                        var types = postcode.types;
                                        if($.inArray('postal_code', types) !== -1) {
                                            $postcode.val(postcode.long_name);
                                            $postcode.parents('.form-group').addClass('filled');
                                        }
                                    }
                                    if($form.hasClass('js-submit-on-geolocation')){
                                        $form.find('.ajax-submit').trigger('click');
                                    }
                                });
                            };
                            function error(position){
                                console.log(position);
                            };
                            navigator.geolocation.getCurrentPosition(success, error);
                        }
                    }

                    checkConflicts();

                    function checkConflicts(){
                        $form.find('.house-types [data-type]').removeClass('disabled');
                        $form.find('[data-conflicts]').each(function(){
                            var conflicts = $(this).data('conflicts');
                            if($(this).find('input').is(':checked')){
                                $.each(conflicts, function(key, type) {
                                    $form.find('.house-types [data-type="'+type+'"]').addClass('disabled');
                                });
                            }
                        });
                        $form.find('[data-conflicts-select]').each(function(){
                            var conflicts = $(this).data('conflicts-select');
                            if(conflicts[$(this).val()] !== undefined){
                                $.each(conflicts[$(this).val()], function(key, type) {
                                    $form.find('.house-types [data-type="'+type+'"]').addClass('disabled');
                                });
                            }
                        });
                        $form.find('[data-conflicts]').removeClass('disabled');
                        $form.find('[data-conflicts-select]').next('.nice-select').find('.option').removeClass('disabled');
                        $form.find('[data-type]').each(function(){
                            if($(this).find('input').is(':checked')){
                                var type = $(this).data('type');
                                $form.find('[data-conflicts*="'+type+'"]').addClass('disabled');
                                $form.find('[data-conflicts-select]').each(function(){
                                    var $parent = $(this).parent();
                                    var conflicts = $(this).data('conflicts-select');
                                    $.each(conflicts, function(key, value){
                                        if($.inArray(type, value) !== -1){
                                            $parent.find('.option[data-value="'+key+'"]').addClass('disabled');
                                        }
                                    });
                                });
                            }
                        });
                    }

                    if($form.hasClass('js-update-url')){
                        $form.find('.ajax-submit').on('click', function(){
                            var model = {}; 
                            $.map($form.serializeArray(), function (n, i) {
                                if(model[n['name']] !== undefined && Array.isArray(model[n['name']])){
                                    model[n['name']].push(n['value']);
                                }else if(model[n['name']] !== undefined){
                                    model[n['name']] = [model[n['name']], n['value']]
                                }else{
                                    model[n['name']] = n['value'];
                                }
                            });
                            $.each(model, function(k,v){
                                if(v === ''){
                                    delete model[k];
                                }
                            });
                            history.pushState({}, null, window.location.pathname + '?' + decodeURIComponent(new URLSearchParams(model).toString()));
                        });
                    }

                    $form.find('.js-fake-submit').on('click', function(){
                        $form.find('.ajax-submit').trigger('click');
                    });
                });
                
                $('.js-filters-toggle').on('click', function(){
                    $(this).siblings('.filters').addClass('open');
                    $(this).siblings('.js-filters-form').find('.filters').addClass('open');
                    $(this).parents('.mobile-finder-cta').siblings('.filters').addClass('open');
                });
    
                $('.js-filters-close').on('click', function(){
                    $(this).parents('.filters').removeClass('open');
                    if($(this).parents('.js-filters-form').length){
                        $('html, body').animate({
                            scrollTop: $(this).parents('.js-filters-form').offset().top
                        }, 100);
                    }
                });

                $('.js-filters-sort').on('change', function(){
                    $('.js-filters-form input[name="sort"]').val($(this).val());
                    $('.js-filters-form .ajax-submit').trigger('click');
                });

                $('.js-filters-sticky-show').on('click', function(){
                    $('.js-filters-sticky').addClass('visible');
                });

                if($('.js-scroll-to-filters').length){
                    $('html, body').animate({
                        scrollTop: $forms.parents('.filters').offset().top
                    }, 100);
                }

                $(window).resize(function() {
                    if($('.js-filters-extra:visible').length){
                        $('.js-filters-spacer').css('height', $('.js-filters-extra').outerHeight() + 'px');
                    }else{
                        $('.js-filters-extra').show();
                        $('.js-filters-spacer').css('height', $('.js-filters-extra').outerHeight() + 'px');
                        $('.js-filters-extra').css('display', '');
                    }
                })

                $(window).trigger('resize');

                if($('.js-filters-sticky').length){
                    $(window).on('scroll', function(){
                        if($(window).scrollTop() > $('.results').offset().top){
                            $('.js-filters-sticky').addClass('fixed');
                        }else{
                            $('.js-filters-sticky').removeClass('fixed visible');
                        }
                    });
                }
            }
        });
    };

    return {
        init:init
    };
};

export default Filters;